import React, { useRef, useState, useEffect } from "react";
import { toast } from "react-toastify";
import { modifyEnvelopeRequestInformation } from "../../../../services/CommonService";
import Utils from "../../../../utils";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import {
  DATE_FORMAT_LIST,
  FORM_OPTIONS,
  QUILL_MODULES,
  QUILL_FORMATS,
} from "../../../../configs/AppConfig";
// import {CKEditor} from '@ckeditor/ckeditor5-react';
// import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

import DatePicker from "react-datepicker";

// import FroalaEditor from 'react-froala-wysiwyg';

// Require Editor CSS files.
// import 'froala-editor/css/froala_style.min.css';
// import 'froala-editor/css/froala_editor.pkgd.min.css';
// import 'froala-editor/js/plugins.pkgd.min.js';
// import 'froala-editor/js/plugins/align.min.js';

import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css"; // Import the Quill stylesheet

function EnvelopeRequestForm(props) {
  const [formId, setFormId] = useState(0);
  const [formRequestId, setFormRequestId] = useState([]);
  const [formRecipients, setFormRecipients] = useState([]);
  const [formName, setFormName] = useState("");
  const [formQuestions, setFormQuestions] = useState([]);
  const [removeQuestionId, setRemoveQuestionId] = useState([]);
  const [removeOptionId, setRemoveOptionId] = useState([]);

  const [previewButtonText, setPreviewButtonText] = useState("Preview");
  const [previewContent, setPreviewContent] = useState("");

  const animatedComponents = makeAnimated();

  const questionDragItem = useRef();
  const questionDragOverItem = useRef();
  const dateRef = useRef(null);

  const questionDragStart = (e, position) => {
    questionDragItem.current = position;
  };

  const questionDragEnter = (e, position) => {
    questionDragOverItem.current = position;
  };

  const questionDrop = (e) => {
    const copyListItems = [...formQuestions];
    const dragItemContent = copyListItems[questionDragItem.current];
    copyListItems.splice(questionDragItem.current, 1);
    copyListItems.splice(questionDragOverItem.current, 0, dragItemContent);
    questionDragItem.current = null;
    questionDragOverItem.current = null;
    setFormQuestions(copyListItems);
  };

  useEffect(() => {
    setFormId(props?.requestFormData?.id);
    setFormName(props?.requestFormData?.form_name);
    setFormQuestions(props?.requestFormData?.form_questions);

    if (props?.requestFormData?.request_id) {
      let selectedRecipient = [];
      let recipientIds = props?.requestFormData?.request_id.split(",");
      // If only '0' (Everyone) is present, select ALL actual recipients
      if (recipientIds.length === 1 && parseInt(recipientIds[0]) === 0) {
        selectedRecipient = (props.formObj.recipient_List || []).map((r) => ({
          value: r["id"],
          label: r["first_name"] + " " + r["last_name"],
        }));
      } else {
        for (let i = 0; i < recipientIds.length; i++) {
          if (parseInt(recipientIds[i]) !== 0) {
            let index = props.formObj.recipient_List.findIndex(
              (x) => parseInt(x.id) === parseInt(recipientIds[i])
            );
            if (index > -1) {
              selectedRecipient.push({
                value: props.formObj.recipient_List[index]["id"],
                label:
                  props.formObj.recipient_List[index]["first_name"] +
                  " " +
                  props.formObj.recipient_List[index]["last_name"],
              });
            }
          }
        }
      }
      setFormRequestId(selectedRecipient);
    } else {
      // Set default selected recipient as first actual recipient instead of empty
      if (props.formObj?.recipient_List && props.formObj.recipient_List.length > 0) {
        const firstRecipient = {
          value: props.formObj.recipient_List[0]['id'],
          label: props.formObj.recipient_List[0]['first_name'] + ' ' +
            props.formObj.recipient_List[0]['last_name'],
        };
        setFormRequestId([firstRecipient]);
      } else {
        setFormRequestId([]); // No default selection if no recipients available
      }
    }

    let recipients = [];
    for (let i = 0; i < props.formObj.recipient_List.length; i++) {
      recipients.push({
        value: props.formObj.recipient_List[i]["id"],
        label:
          props.formObj.recipient_List[i]["first_name"] +
          " " +
          props.formObj.recipient_List[i]["last_name"],
      });
    }
    setFormRecipients(recipients);
  }, [props?.requestFormData, props.formObj.recipient_List]);

  let errorsObj = {
    recipients: "",
    form_name: "",
  };
  const [errors, setErrors] = useState(errorsObj);

  const clsFormButtonRef = useRef(null);

  function onCloseForm(e) {
    e.preventDefault();
    clsFormButtonRef.current?.click();
    clearForm(e);
  }

  function clearForm(e) {
    e.preventDefault();
    setFormId(0);

    // Set default selected recipient as first actual recipient
    if (props.formObj?.recipient_List && props.formObj.recipient_List.length > 0) {
      const firstRecipient = {
        value: props.formObj.recipient_List[0]['id'],
        label: props.formObj.recipient_List[0]['first_name'] + ' ' +
          props.formObj.recipient_List[0]['last_name'],
      };
      setFormRequestId([firstRecipient]);
    } else {
      // No recipients available
      setFormRequestId([]);
    }

    setFormName("");
    setFormQuestions([]);

    let errorsObj = {
      recipients: "",
      form_name: "",
    };
    setErrors(errorsObj);
  }

  function onAddField(e, type) {
    setPreviewContent("");
    setPreviewButtonText("Preview");

    e.preventDefault();
    let list = [...formQuestions];

    let options = [];
    if (type === 4 || type === 5) {
      for (let i = 1; i <= 3; i++) {
        options.push({
          id: 0,
          name: "",
        });
      }
    }

    list.push({
      id: 0,
      type: type,
      name: "",
      sub_label: "",
      is_show: false,
      options: options,
      select_options: "",
      date: "",
    });
    setFormQuestions(list);
  }

  function onRemoveField(e, index, data) {
    e.preventDefault();
    let list = [...formQuestions];
    list.splice(index, 1);
    setFormQuestions(list);
    if (data.id > 0) {
      let rmQuestionIds = [...removeQuestionId];
      rmQuestionIds.push(data.id);
      setRemoveQuestionId(rmQuestionIds);
    }
  }

  function handleFieldInput(e, index) {
    e.preventDefault();
    let list = [...formQuestions];
    list[index].name = e.target.value;
    setFormQuestions(list);
  }

  function handleSubLabel(e, index) {
    e.preventDefault();
    let list = [...formQuestions];
    list[index].sub_label = e.target.value;
    setFormQuestions(list);
  }

  function onAddFieldOption(e, index) {
    e.preventDefault();
    let list = [...formQuestions];
    list[index].options.push({
      id: 0,
      name: "",
    });
    setFormQuestions(list);
  }

  function onAddFieldDate(e, index) {
    e.preventDefault();
  }

  function onRemoveFieldOption(e, index, idx, data) {
    e.preventDefault();
    let list = [...formQuestions];
    list[index].options.splice(idx, 1);
    setFormQuestions(list);
    if (data.id > 0) {
      let rmOptionIds = [...removeOptionId];
      rmOptionIds.push(data.id);
      setRemoveOptionId(rmOptionIds);
    }
  }

  function handleOptionInput(e, index, idx) {
    e.preventDefault();
    let list = [...formQuestions];
    list[index].options[idx].name = e.target.value;
    setFormQuestions(list);
  }

  function onSaveAddForm(e) {
    e.preventDefault();
    storeFormField(e, 2);
  }

  function onSaveForm(e) {
    e.preventDefault();
    storeFormField(e, 1);
  }

  function storeFormField(e, type) {
    let error = false;
    const errorObj = { ...errorsObj };

    let list = [...formQuestions];
    if (formRequestId.length === 0) {
      errorObj.recipients = "Please select request from";
      error = true;
    }
    if (!formName) {
      errorObj.form_name = "Name must be required";
      error = true;
    } else if (list.length === 0) {
      toast.error("Please add any one option");
      error = true;
    }
    if (list.length > 0) {
      for (let i = 0; i < list.length; i++) {
        if (!list[i].name) {
          if (list[i].type !== 7) {
            list[i].error = "Question is required";
            error = true;
          }
        } else if (
          list[i].type > 2 &&
          list[i].type < 6 &&
          list[i].options.length === 0
        ) {
          list[i].error = "Please add option";
          error = true;
        } else {
          list[i].error = "";
        }
        if (list[i].options.length > 0) {
          for (let j = 0; j < list[i].options.length; j++) {
            if (!list[i].options[j].name) {
              list[i].options[j].error = "Option is required";
              error = true;
            } else {
              list[i].options[j].error = "";
            }
          }
        }
      }
    }

    setFormQuestions(list);

    setErrors(errorObj);

    if (error) return;

    let envelopeFormData = { ...props.formObj };

    let recipientIds = formRequestId.map((r) => r["value"]).join(",");

    props.setLoading(true);
    let obj = {
      envelope_id: envelopeFormData.envelope_id,
      form_id: formId,
      form_request_id: recipientIds,
      name: formName,
      fields: formQuestions,
      remove_question: removeQuestionId,
      remove_option: removeOptionId,
    };

    modifyEnvelopeRequestInformation(obj)
      .then((response) => {
        if (type === 1) {
          clsFormButtonRef.current?.click();
          clearForm(e);
        } else {
          clearForm(e);
        }

        let requestDisplay = [];
        if (recipientIds) {
          let recipients = recipientIds.split(",");
          for (let i = 0; i < recipients.length; i++) {
            let index = envelopeFormData.recipient_List.findIndex(
              (x) => parseInt(x.id) === parseInt(recipients[i])
            );
            if (index > -1) {
              let firstName =
                envelopeFormData.recipient_List[index]["first_name"];
              let lastName =
                envelopeFormData.recipient_List[index]["last_name"];
              let firstLetter = firstName.charAt(0);
              let lastLetter = lastName.charAt(0);
              requestDisplay.push({
                full_name: firstName + " " + lastName,
                display: firstLetter + lastLetter,
              });
            }
          }
        }

        if (formId > 0) {
          let index = envelopeFormData.fill_forms.findIndex(
            (x) => parseInt(x.id) === parseInt(formId)
          );
          if (index > -1) {
            envelopeFormData.fill_forms[index]["name"] = formName;
            envelopeFormData.fill_forms[index]["request_id"] = recipientIds;
            envelopeFormData.fill_forms[index]["request_display"] =
              requestDisplay;
            envelopeFormData.fill_forms[index]["questions"] = formQuestions;
          }
        } else {
          envelopeFormData.fill_forms.push({
            id: response.data.id,
            name: formName,
            request_id: recipientIds,
            request_display: requestDisplay,
            questions: formQuestions,
          });
        }

        let frmObj = {
          id: 0,
          request_id: 0,
          form_name: "",
          form_questions: [],
        };
        props.setRequestFormData(frmObj);

        props.setFormObj(envelopeFormData);

        props.setLoading(false);
        toast.success(response.data.message);
      })
      .catch((err) => {
        props.setLoading(false);
        toast.error(Utils.getErrorMessage(err));
      });
  }

  const handleFormRequestRecipient = (options) => {
    setFormRequestId(options || []);
  };

  const handleSelectBox = (e, index) => {
    e.preventDefault();
    let list = [...formQuestions];
    list[index].is_show = true;
    setFormQuestions(list);
  };

  const handleSelectBoxHide = (e, index) => {
    e.preventDefault();
    let list = [...formQuestions];

    let existOptions = list[index].options;
    let value = list[index].select_options;
    if (value) {
      let split = value.split("\n");
      let options = [];
      for (let i = 0; i < split.length; i++) {
        if (split[i].trim()) {
          let id = 0;
          if (existOptions[i] && existOptions[i]["id"]) {
            id = parseInt(existOptions[i]["id"]);
          }
          options.push({
            id: id,
            name: split[i].trim(),
          });
        }
      }

      if (split.length < existOptions.length) {
        let rmOptionIds = [...removeOptionId];
        for (let i = split.length; i < existOptions.length; i++) {
          if (existOptions[i]["id"]) {
            if (parseInt(existOptions[i]["id"]) > 0) {
              rmOptionIds.push(parseInt(existOptions[i]["id"]));
            }
          }
        }
        setRemoveOptionId(rmOptionIds);
      }
      list[index].options = options;
    }

    list[index].is_show = false;
    setFormQuestions(list);
  };

  const handleSelectOption = (e, index) => {
    e.preventDefault();
    let list = [...formQuestions];

    list[index].select_options = e.target.value;
    setFormQuestions(list);
  };

  const showDatePlaceholder = (id) => {
    let value = "";
    let index = DATE_FORMAT_LIST.findIndex(
      (x) => parseInt(x.id) === parseInt(id)
    );
    if (index > -1) {
      value = DATE_FORMAT_LIST[index]["text"];
    }
    return value;
  };

  function togglePreview() {
    let list = [...formQuestions];
    if (list.length > 0) {
      setPreviewContent("");
      if (previewButtonText === "Preview") {
        let blankNameRecord = list.some(
          (item) => item.name === "" && item.type !== 7
        );
        if (blankNameRecord) {
          toast.error("Please enter the field name.");
          return false;
        }

        setPreviewButtonText("Turn Off Preview");

        // Create preview content based on formQuestions
        const previewElements = list.map((item, index) => (
          <div key={index} className="mb-4">
            <label className="form-label mb-2">{item.name}</label>
            {item.type === 1 && (
              <input type="text" disabled={true} className="form-control" />
            )}
            {item.type === 2 && (
              <textarea
                className="form-control"
                value=""
                disabled={true}
                rows="3"
              />
            )}
            {item.type === 3 && (
              <select className="form-select" value="" disabled={true}>
                <option value="">Please select</option>
              </select>
            )}
            {item.type === 4 && (
              <>
                {item.options.map((option, o) => (
                  <div key={o} className="form-check">
                    <input
                      type="radio"
                      disabled={true}
                      name={`radio_option_${index}`}
                      value={option.id}
                      id={`radio_option_${index}_${o}`}
                      className="form-check-input"
                    />
                    <label
                      htmlFor={`radio_option_${index}_${o}`}
                      className="form-check-label"
                    >
                      {option.name}
                    </label>
                  </div>
                ))}
              </>
            )}
            {item.type === 5 && (
              <>
                {item.options.map((option, o) => (
                  <div key={o} className="form-check">
                    <input
                      type="checkbox"
                      disabled={true}
                      value={option.id}
                      checked={option.checked}
                      id={`checkbox_option_${index}_${o}`}
                      className="form-check-input"
                    />
                    <label
                      htmlFor={`checkbox_option_${index}_${o}`}
                      className="form-check-label"
                    >
                      {option.name}
                    </label>
                  </div>
                ))}
              </>
            )}
            {item.type === 6 && (
              <>
                <div className="card p-2 w-100">
                  <div className="drag-area">
                    <div className="icon">
                      <i className="bi bi-cloud-arrow-up" aria-hidden="true" />
                    </div>
                    <h5>
                      Drag &amp; Drop to Upload File here or click to upload
                    </h5>
                  </div>
                </div>
              </>
            )}
            {item.type === 7 && (
              <>
                <div
                  className="mb-0"
                  dangerouslySetInnerHTML={{ __html: item.select_options }}
                />
              </>
            )}

            {item.type === 8 && (
              <div className="">
                <div className="position-relative">
                  <DatePicker
                    ref={dateRef}
                    className="form-control"
                    placeholderText={showDatePlaceholder(2)}
                    disabled
                  />
                  <i
                    className="bi bi-calendar"
                    style={{ top: "15px" }}
                    onClick={(e) => dateRef?.current.setFocus(true)}
                  />
                </div>
              </div>
            )}

            <div className="mt-2">{item.sub_label}</div>
          </div>
        ));

        // Set the generated preview content
        setPreviewContent(previewElements);
      } else {
        setPreviewButtonText("Preview");
      }
    } else {
      toast.error("Please select any one form field.");
      return false;
    }
  }

  function handleModelChange(value, index) {
    const updatedQuestions = [...formQuestions];
    updatedQuestions[index].select_options = value;
    setFormQuestions(updatedQuestions);
  }

  useEffect(() => {
    const offcanvasElement = document.getElementById("MakeForm");

    const handleShown = () => {
      setPreviewContent("");
      setPreviewButtonText("Preview");
    };

    const handleHidden = () => {
      setPreviewContent("");
      setPreviewButtonText("Preview");
    };

    offcanvasElement.addEventListener("shown.bs.offcanvas", handleShown);
    offcanvasElement.addEventListener("hidden.bs.offcanvas", handleHidden);

    return () => {
      offcanvasElement.removeEventListener("shown.bs.offcanvas", handleShown);
      offcanvasElement.removeEventListener("hidden.bs.offcanvas", handleHidden);
    };
  }, []);

  return (
    <div
      className="offcanvas offcanvas-end w-80 AddDocument MakeForm"
      data-bs-scroll="false"
      data-bs-backdrop="static"
      data-bs-keyboard="true"
      tabIndex="-1"
      id="MakeForm"
      aria-labelledby="MakeFormLabel"
    >
      <div className="offcanvas-header">
        <h5 className="offcanvas-title" id="MakeFormLabel">
          {formId > 0 ? `Edit Form` : `Create Form`}
        </h5>
        <button
          type="button"
          ref={clsFormButtonRef}
          className="btn btn-close close_btn text-reset "
          data-bs-dismiss="offcanvas"
          onClick={clearForm}
          aria-label="Close"
        ><i className="bi bi-x-circle" aria-hidden="true" /></button>
      </div>
      <div
        className="offcanvas-body p-0 request-form-body"
        style={{ overflowX: "hidden" }}
      >
        <div className="row p-0 m-0">
          <div className="requestform-create-sleeve-sidebar col-lg-4 col-xl-4 col-xxl-3 p-0">
            <div className="requestform-create-sleeve-sidebar-scroll">
              <ul className="requestform-create-sleeve-form-fields">
                {FORM_OPTIONS &&
                  FORM_OPTIONS.map((item, index) => (
                    <li
                      key={index}
                      onClick={(event) => onAddField(event, item.type)}
                      className="requestform-create-sleeve-field-btn"
                      style={{ cursor: "pointer" }}
                    >
                      <span className="requestform-create-sleeve-icon-wrap">
                        <img src={`/images/${item.icon}`} alt={item.name} />
                        {item.name}
                      </span>
                    </li>
                  ))}
              </ul>
            </div>
          </div>

          <div className="requestform-create-sleeve-main-scroll col-lg-8 col-xl-8 col-xxl-9 p-4">
            <div className="form-group mb-4 d-inline">
              <div className="form-section-wrapper">
                <div className="row">
                  <div className="col-12 col-lg-6 mb-3 mb-lg-0">
                    <div className="form-section-card h-100">
                      <div className="form-section-header">
                        <h2 className="form-section-title">
                          Request Information From
                          <i
                            className="bi bi-info-circle"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Select the recipient's name from whom you want to collect information."
                          />
                        </h2>
                      </div>
                      <div className="form-section-body">
                        <div className="row">
                          <div className="col-12">
                            {formRequestId.map((recipient, index) => (
                              <div key={recipient.value} className="modern-input-wrapper mb-2">
                                <input
                                  type="text"
                                  className="modern-input"
                                  value={recipient.label}
                                  readOnly
                                  placeholder="Recipient name"
                                />
                                <i
                                  className="bi bi-person-check modern-info-icon text-success"
                                  aria-hidden="true"
                                />
                              </div>
                            ))}
                            {errors.recipients && (
                              <div className="form-section-error">
                                {errors.recipients}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col-12 col-lg-6">
                    <div className="form-section-card h-100">
                      <div className="form-section-header">
                        <h2 className="form-section-title">
                          Enter Form Name
                          <i
                            className="bi bi-info-circle"
                            data-toggle="tooltip"
                            data-placement="right"
                            title="Give any name to Information list."
                          />
                        </h2>
                      </div>
                      <div className="form-section-body">
                        <div className="row">
                          <div className="col-12">
                            <input
                              type="text"
                              className="form-section-input"
                              value={formName}
                              onChange={(e) => setFormName(e.target.value)}
                              placeholder="Enter Form Name"
                            />
                            {errors.form_name && (
                              <div className="form-section-error">
                                {errors.form_name}
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="accordion ps_sm_4 pe-4 mt-3" id="AdditionalField">
              {previewContent === "" ? (
                <div className="step_wizard_content">
                  {formQuestions.length === 0 ? (
                    <div className="text-center">
                      <div className="mb-4">
                        <i className="bi bi-file-earmark-text fs-1 text-primary"></i>
                      </div>
                      <div className="empty-state-message">
                        <h4 className="text-dark mb-3">No Fields Added Yet</h4>
                        <p className="text-muted mb-4">
                          Please select form fields from the left sidebar to
                          start building your form
                        </p>
                      </div>
                    </div>
                  ) : (
                    formQuestions.map((item, index) => (
                      <div key={index} className="question-item-container">
                        <div className="question-card">
                          <div
                            className={`question-header ${item.type === 7 ? "question-header" : ""
                              }`}
                          >
                            <img
                              onDragStart={(e) => questionDragStart(e, index)}
                              draggable
                              onDragEnter={(e) => questionDragEnter(e, index)}
                              onDragEnd={questionDrop}
                              src="/images/dots_rectangle.webp"
                              alt="img"
                              className="drag-handle"
                            />
                            {item.type !== 7 && (
                              <input
                                type="text"
                                value={item.name}
                                className="question-input"
                                onChange={(e) => handleFieldInput(e, index)}
                                placeholder={
                                  item.type === 7
                                    ? "Enter Comments Title"
                                    : "Type a Question"
                                }
                              />
                            )}
                          </div>
                          {item.error && (
                            <div className="error-message">{item.error}</div>
                          )}

                          {item.type === 1 && (
                            <input
                              type="text"
                              className="answer-input"
                              readOnly
                              onChange={(e) => console.log(e)}
                            />
                          )}

                          {item.type === 2 && (
                            <textarea
                              className="answer-textarea"
                              rows="3"
                              readOnly
                              onChange={(e) => console.log(e)}
                              style={{ height: "unset" }}
                            />
                          )}

                          {item.type === 3 && (
                            <>
                              <select
                                className="answer-dropdown"
                                onClick={(e) => handleSelectBox(e, index)}
                                disabled
                              >
                                <option value="">Please select</option>
                                {item.options.map((option, o) => (
                                  <option key={o} value={option.name}>
                                    {option.name}
                                  </option>
                                ))}
                              </select>

                              {item.is_show && (
                                <textarea
                                  placeholder="Please enter each options in a separate line"
                                  className="options-textarea"
                                  rows="5"
                                  value={
                                    item.select_options ||
                                    item.options.map((o) => o.name).join("\n")
                                  }
                                  onChange={(e) => handleSelectOption(e, index)}
                                  style={{ height: "unset" }}
                                />
                              )}
                            </>
                          )}

                          {item.type > 3 && item.type < 6 && (
                            <>
                              {item.options.map((option, idx) => (
                                <div key={idx} className="option-row">
                                  <div className="option-selector">
                                    {item.type === 4 && (
                                      <input
                                        type="radio"
                                        className="form-radio"
                                      />
                                    )}
                                    {item.type === 5 && (
                                      <input
                                        type="checkbox"
                                        className="form-checkbox"
                                      />
                                    )}
                                  </div>
                                  <div className="option-input-container">
                                    <input
                                      type="text"
                                      value={option.name}
                                      placeholder={`Type Option ${idx + 1}`}
                                      onChange={(e) =>
                                        handleOptionInput(e, index, idx)
                                      }
                                      className="option-input"
                                      style={{ height: "25px" }}
                                    />
                                    {option.error && (
                                      <div className="error-message">
                                        {option.error}
                                      </div>
                                    )}
                                  </div>
                                  <div className="option-remove">
                                    <i
                                      onClick={(e) =>
                                        onRemoveFieldOption(
                                          e,
                                          index,
                                          idx,
                                          option
                                        )
                                      }
                                      className="remove-icon bi bi-x"
                                    />
                                  </div>
                                </div>
                              ))}
                            </>
                          )}

                          {item.type === 6 && (
                            <div className="file-upload-area">
                              <div className="upload-icon">
                                <i
                                  className="bi bi-cloud-arrow-up"
                                  aria-hidden="true"
                                />
                              </div>
                              <h5>
                                Drag & Drop to Upload File here or click to
                                upload
                              </h5>
                            </div>
                          )}

                          {item.type > 3 && item.type < 6 && (
                            <span
                              className="add-option-button"
                              onClick={(e) => onAddFieldOption(e, index)}
                            >
                              Add option
                            </span>
                          )}

                          {item.type === 3 && (
                            <>
                              {item.is_show === false && (
                                <span
                                  className="edit-options-button"
                                  onClick={(e) => handleSelectBox(e, index)}
                                >
                                  Edit option
                                </span>
                              )}
                              {item.is_show === true && (
                                <span
                                  className="save-options-button"
                                  onClick={(e) => handleSelectBoxHide(e, index)}
                                >
                                  Save option
                                </span>
                              )}
                            </>
                          )}

                          {item.type === 7 && (
                            <div className="rich-text-editor-container">
                              <ReactQuill
                                value={item.select_options}
                                onChange={(value) =>
                                  handleModelChange(value, index)
                                }
                                modules={QUILL_MODULES}
                                formats={QUILL_FORMATS}
                                placeholder="Enter your comments here"
                                className="rich-text-editor"
                              />
                            </div>
                          )}

                          {item.type === 8 && (
                            <div className="date-picker-container">
                              <div className="date-picker-wrapper">
                                <DatePicker
                                  ref={dateRef}
                                  className="date-input"
                                  placeholderText={showDatePlaceholder(2)}
                                  onChange={(e) => onAddFieldDate(e, index)}
                                  disabled
                                />
                                <i
                                  className="bi bi-calendar"
                                  style={{ top: "5px" }}
                                  onClick={(e) =>
                                    dateRef?.current.setFocus(true)
                                  }
                                />
                              </div>
                            </div>
                          )}

                          {item.type !== 7 && (
                            <input
                              type="text"
                              value={item.sub_label}
                              className="help-text-input"
                              onChange={(e) => handleSubLabel(e, index)}
                              placeholder="Enter Question help text here"
                            />
                          )}
                        </div>
                        <button className="delete-question-button">
                          <i
                            className="bi bi-trash ms-2"
                            onClick={(e) => onRemoveField(e, index, item)}
                            aria-hidden="true"
                          />
                        </button>
                      </div>
                    ))
                  )}
                </div>
              ) : (
                <div className="form-preview">{previewContent}</div>
              )}
            </div>
          </div>
        </div>
      </div>
      <div className="modern-footer">
        <button
          type="button"
          onClick={togglePreview}
          className="toggle_btn_preview"
        >
          <strong>
            <i className="bi bi-eye"></i> {previewButtonText}
          </strong>
        </button>

        <button
          type="button"
          onClick={onCloseForm}
          className="btn-back-outline"
        >
          Cancel
        </button>
        {formId === 0 && (
          <button
            type="button"
            onClick={onSaveAddForm}
            className="btn-save-outline"
          >
            Save & Add Another
          </button>
        )}
        <button
          type="button"
          onClick={onSaveForm}
          className="btn modern-save-btn"
        >
          Save
        </button>
      </div>
    </div>
  );
}

export default EnvelopeRequestForm;
